import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "initData"]

  connect() {
    this.submitIfReady()
  }

  disconnect() {
    if (this.initDataTimer) {
      clearTimeout(this.initDataTimer)
    }
  }

  submitIfReady(attempt = 0) {
    window.WebApp?.ready?.()

    if (this.element.dataset.submitted === "true") {
      return
    }

    if (window.WebApp?.initData) {
      this.initDataTarget.value = window.WebApp.initData
      this.element.dataset.submitted = "true"
      this.formTarget.requestSubmit()
      return
    }

    if (attempt >= 20) {
      return
    }

    this.initDataTimer = setTimeout(() => this.submitIfReady(attempt + 1), 150)
  }
}
